// var base = require('kiosk/kiosk');

Vue.component('spark-kiosk', {
    mixins: [require('mixins/tab-state')],
    data() {
        return {
            page: 'announcements',
            pages: [{
                title: 'Announcements',
                icon: 'notifications',
                link: 'announcements'
            },{
                title: 'Metrics',
                icon: 'show_chart',
                link: 'metrics'
            },{
                title: 'Users',
                icon: 'people',
                link: 'users'
            }]
        };
    },
    methods: {
        usePushStateForTabs() {

            // Update active tab on load
            this.updateTab(null);
        },
        updateTab: function(tab) {

            // Get parameters from url
            var hash = window.location.hash.substring(2),
                parameters = hash.split('/');
            hash = parameters.shift();

            // On load, set active tab from url (if present) or default
            if(!tab){
                if(hash.length > 0){
                    tab = hash;
                }else{
                    tab = this.page;
                }
            }

            // Don't update url if looking at user profile
            if(parameters.length < 1){
                window.location.hash = '/'+tab;
            }

            // Update Tab and run Spark functions
            this.page = tab;
            this.broadcastTabChange(this.page, parameters);
        }
    },
	props: ['user']
});
